import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'

//Alpine JS Interactive Components

Alpine.plugin(focus)

Alpine.store('toggleMobileNav', {
    status: false,
   
    toggle() {
        this.status = !this.status
    },
})

window.Alpine = Alpine

Alpine.start()